/** @jsxImportSource @emotion/react */
import { GuideBlock } from '../GuideComponent';
import Accordion from '@mui/material/Accordion';
import { AccodianWrap, GlobalBtnGroup } from 'components/layouts/ContentLayout';
import React, { useEffect, useState } from 'react';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import CustomTextarea from 'components/inputs/CustomTextarea';
import Button from '@mui/material/Button';
import { IconButton } from '../../../../components/buttons/IconSVG';
import { useTranslation } from 'react-i18next';
import { Condition, Translation, TranslationBody } from 'models/admin/Translation';
import { getTranslatedText } from 'apis/admin/Translation';
import { ComboBox, MultiComboBox } from '../../../../components/selects/ComboBox';
import { getCommonCodeNames } from 'apis/admin/CommonCode';
import { Code } from 'models/common/CommonCode';
import { useMessageBar } from '../../../../hooks/useMessageBar';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import _ from 'lodash';

const FileConverterGuide = () => {
  const { t } = useTranslation();
  const { openMessageBar } = useMessageBar();
  const [expanded, setExpanded] = useState<string>('panel1');

  const [langCode, setLangCode] = useState<Code[]>([]);

  useEffect(() => {
    // 언어설정.. setCondition({ ...condition, source: 'ko', targetStr: 'en,zh' });
    initCondition();
  }, []);

  const initCondition = async () => {
    const langCode = await getCommonCodeNames('TRAN_LANG_CD');
    setLangCode(langCode);
  };

  const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : '');
  };

  const handleOnChange = (name, value) => {
    setCondition({ ...condition, [name]: value });
  };

  const [condition, setCondition] = useState<Condition>();
  const [translation, setTranslation] = useState<Translation>();

  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleSearch = async () => {
    if (_.isEmpty(condition?.source)) {
      openMessageBar({
        type: 'error',
        content: t('com.msg.언어를 선택해주세요.', '언어를 선택해주세요.'),
      });
      return;
    }

    if (_.isEmpty(condition?.targetStr)) {
      openMessageBar({
        type: 'error',
        content: t('com.msg.언어를 선택해주세요.', '언어를 선택해주세요.'),
      });
      return;
    }

    if (_.isEmpty(condition?.message)) {
      openMessageBar({
        type: 'error',
        content: t('com.msg.내용을 입력해주세요.', '내용을 입력해주세요.'),
      });
      return;
    }

    const response = await getTranslatedText(condition);

    if (response && response.successOrNot === 'Y') {
      const str = response.data ?? '';
      let result;
      if (typeof str === 'string') {
        result = JSON.parse(str) as Translation;
        setTranslation(result);
      }
    } else {
      openMessageBar({
        type: 'error',
        content:
          typeof response.data === 'string'
            ? response.data
            : t('com.msg.오류가 발생하였습니다.', '오류가 발생하였습니다.'),
      });
    }
  };

  return (
    <>
      <AccodianWrap className="marginTop">
        <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
          <AccordionSummary>Translation - Basic</AccordionSummary>
          <AccordionDetails>
            <GuideBlock>
              <ComboBox
                placeholder={String(t('com.label.언어선택', '언어선택'))}
                options={langCode}
                defaultValue={condition?.source}
                onChange={(value: string) => {
                  handleOnChange('source', value);
                }}
              />
              <CustomTextarea
                name="message"
                className="fullWidth"
                style={{ backgroundColor: '#e7ddfd', height: '200px' }}
                placeholder={'번역할 내용을 입력해주세요.'}
                onChange={(e) => handleOnChange(e.target.name, e.target.value)}
              />
              <ArrowDropDownIcon />
              <MultiComboBox
                id="targetStr"
                options={langCode.filter((o) => o.cmnCd != '00')}
                placeholder={String(t('com.label.언어선택', '언어선택'))}
                defaultValue={condition?.targetStr?.split(',')}
                onChange={(value) => {
                  handleOnChange('targetStr', value.join());
                }}
              />

              {(translation?.translations || []).map((item, idx) => (
                <CustomTextarea
                  key={idx}
                  name="result"
                  style={{ height: '120px' }}
                  className="fullWidth"
                  value={`(${item.target}) ${item.result}`}
                  placeholder={'번역된 내용이 표시됩니다.'}
                  readOnly={true}
                />
              ))}
              <GlobalBtnGroup className="between">
                <Button
                  css={IconButton.button}
                  className="edit"
                  onClick={() => handleSearch()}
                  onKeyDown={handleKeyDown}
                  disableRipple
                >
                  {t('com.button.번역', '번역')}
                </Button>
              </GlobalBtnGroup>
            </GuideBlock>
          </AccordionDetails>
        </Accordion>
      </AccodianWrap>
    </>
  );
};

export default FileConverterGuide;
